<template>
  <v-card>
    <v-card-title>
      Edit Projects
    </v-card-title>

    <ProjectFrom 
      :project="project"
      type="UPDATE"
    />
  </v-card>
</template>

<script>
import RestResource from "@/services/dataServiceMobile.js";
import ProjectFrom from "./form"

const service = new RestResource();
export default {
  components: {
    ProjectFrom
  },
  data() {
    return {
      project: {
        activities:[],
      }
    };
  },

  mounted() {
    this.loadProject();
  },

  methods: {
    loadProject() {
      this.$setLoader();

      service.fetchProject({ projectId: this.$route.params.id }).then(r => {
        this.project = r.data[0];
        this.$disableLoader();
      });
    },
  }
};
</script>